import { render, staticRenderFns } from "./Bygninger.vue?vue&type=template&id=aed0f406&"
import script from "./Bygninger.vue?vue&type=script&lang=js&"
export * from "./Bygninger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports